import React from 'react';
import { useLocation, useNavigate, Routes, Route } from "react-router-dom";
import { useAuth } from '../../zeon-react-ui/auth/model';
import Grid from '@mui/material/Unstable_Grid2';
import LanIcon from '@mui/icons-material/Lan';
import PeopleIcon from '@mui/icons-material/People';
import { Stack, Typography, styled, Paper, Container, Alert } from '@mui/material';

import LDAPBlock from './ldap';
import UsersBlock from './users';

const _ACL_LEVEL_ = "G_D_ADMIN_ITALY";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  maxWidth: 144,
  minWidth: 144,
  width: 144,
  maxHeight: 56,
  minHeight: 56,
  height: 56,
  cursor: "pointer"
}));

const SetupForm = () => {
  const user = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  if (!user?.groups.includes(_ACL_LEVEL_)) return (
    <Grid xs={12} sm={6} md={6} lg={4} xl={3} container sx={{ m: 5, p: 0 }}>
      <Alert severity="error" sx={{ width: '100%' }}>
        You are not allowed to access this feature!<br /> Level required: <b>{_ACL_LEVEL_}</b>.
      </Alert>
    </Grid>
  ); else if (location.pathname === "/prefs") return (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
      <Item onClick={() => { navigate("/prefs/ldap") }}>
        <LanIcon fontSize='large' color='disabled' />
        <Typography>LDAP / Active Directory</Typography>
      </Item>
      <Item onClick={() => { navigate("/prefs/users") }}>
        <PeopleIcon fontSize='large' color='disabled' />
        <Typography>User Parameters</Typography>
      </Item>
    </Stack>
  ); else return (
    <Container>
      <Routes>
        <Route path="/ldap" element={<LDAPBlock />} />
        <Route path="/users" element={<UsersBlock />} />
      </Routes>
    </Container >
  );
};

export default SetupForm;